module.exports = "/packs/media/images/youngwork_1-d88f40622da8c5591c2b6706d56e5b31.jpg";